import { getIsLegacyValidationForTicketbookEnabledMerchant } from 'src/utils/getIsLegacyValidationForTicketbookEnabledMerchant';
import {
  ReservationFlowPaymentMethodListTicketBook,
  ReservationFlowTicketBookAvailableReservationCount,
} from '../../../../interfaces/reservation_flow';

import { isExpiredDate } from '../is-expired-date';
import { isRestrictedTicketBookReservationCount } from '../is-restricted-ticket-book-reservation-count';

export const isAvailableTicketBookProduct: (params: {
  merchantTimeZone: string;
  // YYYY-MM-DD もしくは ISO8601 形式
  baseDate: string;
  product: ReservationFlowPaymentMethodListTicketBook['products'][number];
  availableReservationCounts: ReservationFlowTicketBookAvailableReservationCount[];
  merchantPublicId: string;
}) => boolean = ({
  merchantTimeZone,
  baseDate,
  product,
  availableReservationCounts,
  merchantPublicId,
}) => {
  if (product.available_ticket_books.length === 0) {
    return false;
  }

  // 有効期限内の購入済みTicketBookの抽出
  // 特別対応マーチャントの場合は有効期限を見ない
  // issue: https://github.com/heyinc/rsv-issues/issues/21754
  const isLegacyValidationForTicketbook =
    getIsLegacyValidationForTicketbookEnabledMerchant(merchantPublicId);
  const activeAvailableTicketBooks = isLegacyValidationForTicketbook
    ? product.available_ticket_books
    : product.available_ticket_books.filter((availableTicketBook) => {
        return !isExpiredDate({
          date: availableTicketBook.expires_at,
          baseDate,
          merchantTimeZone,
        });
      });

  // 有効期限内の購入済みTicketBookがない場合は利用できない
  if (activeAvailableTicketBooks.length === 0) {
    return false;
  }

  // 回数制限が存在するかの確認
  const isRestricted = activeAvailableTicketBooks.some(
    (availableTicketBook) => {
      const count = availableReservationCounts.find(
        (availableReservationCount) => {
          return (
            availableReservationCount.publicId === availableTicketBook.public_id
          );
        },
      );

      // 関連する回数制限が存在しない場合は制限されているとみなす
      if (typeof count === 'undefined') {
        return true;
      }

      return isRestrictedTicketBookReservationCount(count);
    },
  );

  // 一つでも回数制限が存在する場合は利用できない
  if (isRestricted) {
    return false;
  }

  // 利用可能な購入済みTicketBookから利用可能数の合計を算出
  const totalRemainCount = activeAvailableTicketBooks.reduce((acc, current) => {
    return acc + current.remain_count;
  }, 0);

  // 合計利用可能数が消費数以上の場合は利用可能
  return totalRemainCount >= product.consumption;
};
